'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext, useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';
import ButtonCircle from 'components/ui/ButtonCircle';
import { CarouselContext } from 'components/ui/Carousel';
import Img from 'components/ui/Img';
import Video from 'components/ui/Video';

import VideoPlayerYTPortal from './VideoPlayerYTPortal';

import styles from './VideoPlayerYT.module.scss';

const VideoPlayerYT = ({
    className,
    eyebrow,
    headline,
    textAlign,
    youtubeVideoId,
    image,
    imageLarge,
    index,
    videoTextureMp4,
    videoTextureWebm,
    videoTexturePoster,
    embeddedEntry,
    heroVideo,
    isActive,
    richTextHeadline,
    richTextHeadlineColor,
    richTextHeadlineIcon,
    centerPlayButton,
    threshold,
    lockupTheme,
    firstBlock,
}) => {
    isActive ??= true;
    richTextHeadlineColor ??= 'cream';
    richTextHeadlineIcon ??= 'none';
    threshold ??= 1;

    const { activeIndices } = useContext(CarouselContext);

    const [isOpen, setIsOpen] = useState(false);

    const isInCarousel = activeIndices.length !== 0;

    const handlePlay = () => {
        if (
            (typeof index === 'number' && activeIndices.includes(index)) ||
            !isInCarousel
        ) {
            setIsOpen(true);
        }
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div
                onClick={handlePlay}
                className={cx(styles.videoPlayerYT, className, {
                    [styles.isOpen]: isOpen,
                    [styles.embeddedEntry]: embeddedEntry,
                    [styles.heroVideo]: heroVideo,
                    [styles.isActive]: isActive,
                    [styles.isCentered]: richTextHeadline || centerPlayButton,
                    [styles.centerPlayButton]: centerPlayButton,
                    [styles.textAlignLeft]: textAlign === 'left',
                })}
            >
                <div className={styles.background}>
                    {videoTextureMp4?.url && videoTextureWebm?.url ? (
                        <Video
                            className={styles.image}
                            playState={isOpen ? 'pause' : 'play'}
                            poster={videoTexturePoster?.url}
                            threshold={threshold}
                            sources={[
                                videoTextureWebm.url,
                                videoTextureMp4.url,
                            ]}
                        />
                    ) : image?.url && imageLarge?.url ? (
                        <Img
                            className={styles.image}
                            priority={heroVideo}
                            src={image.url}
                            width={image?.width}
                            height={image?.height}
                            fallbackImageWidth={732}
                            alt={image.description || ''}
                            customSources={[
                                {
                                    breakpoint: 768,
                                    src: imageLarge.url,
                                    imageWidth: 1420,
                                },
                                {
                                    src: image.url,
                                    imageWidth: 732,
                                },
                            ]}
                        />
                    ) : null}
                </div>
                <div className={styles.foreground}>
                    {(richTextHeadline || headline) && (
                        <div
                            className={styles.headlineSandwich}
                            style={{
                                color: `var(--colors-${richTextHeadlineColor})`,
                            }}
                        >
                            <Lockup
                                icon={richTextHeadlineIcon}
                                eyebrow={{ text: eyebrow }}
                                headline={{
                                    text: richTextHeadline || headline,
                                    as: firstBlock ? 'h1' : 'h2',
                                }}
                                theme={lockupTheme}
                            />
                        </div>
                    )}
                    <div className={styles.playVideo}>
                        <ButtonCircle
                            theme={
                                richTextHeadline &&
                                richTextHeadlineColor !== 'cream'
                                    ? 'large-thick-blue'
                                    : 'large-thick-cream'
                            }
                            iconType="playVideo"
                        >
                            <div className="sr-only">
                                Open Video Overlay - {headline}
                            </div>
                        </ButtonCircle>
                    </div>
                </div>
            </div>
            <VideoPlayerYTPortal
                headline={headline}
                youtubeVideoId={youtubeVideoId}
                isOpen={isOpen}
                handleClose={handleClose}
            />
        </>
    );
};

VideoPlayerYT.propTypes = {
    className: PropTypes.string,
    eyebrow: PropTypes.string,
    headline: PropTypes.string,
    youtubeVideoId: PropTypes.string,
    image: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    imageLarge: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    index: PropTypes.number,
    videoTextureMp4: PropTypes.object,
    videoTextureWebm: PropTypes.object,
    videoTexturePoster: PropTypes.object,
    embeddedEntry: PropTypes.bool,
    heroVideo: PropTypes.bool,
    isActive: PropTypes.bool,
    richTextHeadline: PropTypes.object,
    richTextHeadlineColor: PropTypes.string,
    richTextHeadlineIcon: PropTypes.string,
    centerPlayButton: PropTypes.bool,
    threshold: PropTypes.number,
    firstBlock: PropTypes.bool,
};

export default VideoPlayerYT;
